module.exports = __webpack_public_path__ + "static/media/compare-vehicle-screenshot.b870b7ea.png";